import React from 'react'
import useSWRMutation from 'swr/mutation'

import { addCVFeedback } from '../../../api/user-feedback'
import Loading from '../../components/layout/Loading'
import ErrorMessage from '../../components/errors/ErrorMessage'
import CvFeedbackForm from '../../components/user-feedback/FeedbackForm'
import { UserFeedback } from '../../../api/user-feedback/types'
import { useToaster } from '../../../libraries/toaster'
import { useI18N } from '../../../libraries/i18n/hook'

type Props = { cvId: number, jobOfferId?: number }
const CvFeedback: React.FC<Props> = ({ cvId, jobOfferId }) => {
  const { showSuccess } = useToaster()
  const { t } = useI18N()

  const { trigger: triggerAddFeedback, isMutating, error: addFeedbackError } = useSWRMutation(
    `/cv-roaster/${cvId}/feedback`,
    addCVFeedback,
    { onSuccess: () => { showSuccess(t('ai.user.feedback.saved')) } },
  )

  const handleSubmit = async(feedback: UserFeedback) => {
    await triggerAddFeedback({ cvId, jobOfferId, ...feedback })
  }

  if(isMutating) { return <Loading /> }
  if(addFeedbackError) { return <ErrorMessage message='Error adding CV feedback' /> }

  return <CvFeedbackForm onSubmit={handleSubmit} />
}

export default CvFeedback
